import CurrencySelector from '@/screens/dashboard/ui/CurrencySelector'
import { whatsappUrl } from '@/services/common'
import { analytics } from '@repo/analytics'
import { CloseButton, Drawer, Flex, Stack } from '@mantine/core'
import Image from 'next/image'
import Link from 'next/link'
import partment_stay_logo from 'public/images/Partment_logo_from_property_details.svg'
import { FC } from 'react'

const GLOBAL_PORTAL_PATH = '/global-portal'

interface HamburgerMenuProps {
  opened: boolean
  close: () => void
  scrollToSection: (sectionId: string) => void
  isLogin: boolean
  mounted: boolean
}

export const HamburgerMenu: FC<HamburgerMenuProps> = ({
  opened,
  close,
  scrollToSection,
  isLogin,
  mounted,
}) => {
  return (
    <Drawer
      opened={opened}
      onClose={close}
      position='right'
      withCloseButton={false}
    >
      <Flex justify='space-between' align='center'>
        <Image
          src={partment_stay_logo}
          alt='logo black'
          width={100}
          height={80}
        />
        <CloseButton onClick={close} />
      </Flex>
      <Stack mt='sm' gap={5}>
        <button
          onClick={() => {
            scrollToSection('testimonials')
            close()
          }}
          className='!text-left border-b border-b-[#DDE4EA] px-2 py-3 w-full !text-gray-900 text-sm font-medium'
        >
          Testimonials
        </button>
        <Link
          href='/list-your-stay'
          onClick={close}
          className='border-b border-b-[#DDE4EA] px-2 py-3 w-full !text-gray-900 text-sm font-medium'
        >
          List Your Property
        </Link>
        {mounted && isLogin && (
          <>
            <a
              href={GLOBAL_PORTAL_PATH}
              onClick={close}
              className='border-b border-b-[#DDE4EA] px-2 py-3 w-full !text-gray-900 text-sm font-medium'
            >
              Dashboard
            </a>
            <Link
              href='/my-booking'
              onClick={close}
              className='border-b border-b-[#DDE4EA] px-2 py-3 w-full !text-gray-900 text-sm font-medium'
            >
              My Bookings
            </Link>
          </>
        )}

        <CurrencySelector
          className='!text-left border-b border-b-[#DDE4EA] px-2 py-3 w-full !text-gray-900 font-medium'
          setMobileMenuOpen={() => { }}
          placeholderText='Currency'
          width={360}
        />

        <Link target='_blank' href={whatsappUrl} onClick={() => analytics.contactOwner('general', 'whatsapp')}>
          <button
            type='button'
            aria-label='Contact us on WhatsApp'
            className='border-b border-b-[#DDE4EA] px-2 text-left py-3 w-full !text-gray-900 text-sm font-medium'
          >
            Contact us
          </button>
        </Link>
      </Stack>
    </Drawer>
  )
}
export default HamburgerMenu
